import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { WithdrawPayload } from '@monorepo/client-types';
import { Button, Flex, TextComponent } from '@monorepo/react-components';
import { useResponsiveness } from '@monorepo/react-hooks';
import { PaymentMethod } from '@monorepo/types';

interface PaymentMethodsSectionProps {
  form: UseFormReturn<WithdrawPayload>;
  selectedPaymentOption: PaymentMethod | undefined;
  payoutOptions: Array<{ value: PaymentMethod; label: string }>;
}

export const PaymentMethodsSection: React.FC<PaymentMethodsSectionProps> = ({
  form,
  selectedPaymentOption,
  payoutOptions,
}) => {
  const { t } = useTranslation(['withdrawFunds']);
  const { isMobile } = useResponsiveness();

  return (
    <Flex vertical align="center" gap={10}>
      <TextComponent level={5} weight={600}>
        {t('withdrawFunds:payment_methods')}
      </TextComponent>
      <Flex gap={12} vertical={isMobile}>
        {payoutOptions.map((option) => (
          <Button
            key={option.value}
            type={
              selectedPaymentOption === option.value ? 'primary' : 'default'
            }
            className="payment-method-button"
            style={{ width: isMobile ? '317px' : '127px' }}
            onClick={() => {
              form.setValue('paymentOption', option.value, {
                shouldValidate: true,
                shouldDirty: true,
                shouldTouch: true,
              });

              setTimeout(() => {
                form.trigger('amount');
              }, 0);
            }}
          >
            {option.label}
          </Button>
        ))}
      </Flex>
    </Flex>
  );
};
